import React from 'react';
import { dropdown_options, dropdown } from '../partnerStyles';

const DropdownMenu = props => {
  const options = [];
  for (let i in props.options) {
    if (props.options[i].type === 'oyo-hotel') continue;
    options.push(
      <div
        className="s hover"
        onClick={props.options[i].type === 'error'?null:() => {
          if (props.change) props.change(props.options[i]);
        }}
        style={{ ...dropdown_options }}
      >
        <div>{props.options[i].displayName}</div>
      </div>
    );
  }
  return (
    <div
      style={{
        ...dropdown,
        width: props.width ? props.width : '100%',
        top: props.top,
        height: 50 * Math.min(options.length, 5) + 'px',
        ...props.style
      }}
    >
      <span>{options}</span>
    </div>
  );
};

export default DropdownMenu;
